import { createStyles } from '@material-ui/core/styles';

const styles = createStyles((theme) => ({
  borderLeft: {
    [theme.breakpoints.up('sm')]: {
      borderLeft: '1px solid lightgray'
    }
  },
  links: {
    textDecoration: 'underline',
    color: theme.palette.primary.main
  },
  avatar: {
    width: '55px',
    height: '55px',
    margin: 'auto'
  },
  avatarLarge: {
    width: '80px',
    height: '80px',
    margin: 'auto'
  },

  // DriverReserved Card Styles
  driverReservedCard: {
    backgroundColor: 'white',
    borderRadius: '12px',
    padding: '10px 15px 5px 10px',
    margin: '16px 0',
    boxShadow: '0 0px 2px rgb(101 101 101)',
    width: '100%'
  },
  driverInfoSection: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
    gap: '30px'
  },
  driverAvatar: {
    width: '75px',
    height: '75px',
    border: '2px solid #E0E0E0',
    alignSelf: 'flex-start'
  },
  driverDetails: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    textAlign: 'left'
  },
  driverName: {
    fontSize: '15px',
    color: '#333333',
    margin: 0
  },
  plateText: {
    fontSize: '14px',
    color: '#333333',
    margin: 0
  },
  phoneText: {
    fontSize: '14px',
    color: theme.palette.primary.main,
    margin: 0
  },
  driverCheckbox: {
    padding: 0,
    '& .MuiSvgIcon-root': {
      borderRadius: '50%',
      border: '2px solid #666',
      width: '23px',
      height: '23px',
      backgroundColor: 'transparent',
      '& path': {
        display: 'none'
      }
    },
    '&.Mui-checked .MuiSvgIcon-root': {
      backgroundColor: theme.palette.primary.main,
      borderColor: theme.palette.primary.main,
      '& path': {
        display: 'block',
      }
    }
  },
  ratingSection: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    marginBottom: '20px'
  },
  ratingContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '4px'
  },
  starIcon: {
    color: theme.palette.primary.main,
    fontSize: '20px'
  },
  ratingText: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#333'
  },
  servicesText: {
    fontSize: '15px',
    color: '#333',
    margin: 0,
    fontWeight: 500,
  },
  timelineSection: {
    display: 'flex',
    flexDirection: 'column'
  },
  timelineLabels: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '5px'
  },
  timeLabel: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px'
  },
  timeLabelText: {
    fontSize: '12px',
    color: '#000',
    fontWeight: 700,
    margin: 0
  },
  timeValue: {
    fontSize: '13px',
    color: '#333',
    fontWeight: 400,
    margin: 0
  },
  progressBarYellow: {
    height: '17px',
    borderRadius: '4px',
    backgroundColor: '#E0E0E0',
    width: '65%',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#f7a30b',
      borderRadius: '4px',
    }
  },
  progressBarRed: {
    height: '17px',
    borderRadius: '4px',
    backgroundColor: '#E0E0E0',
    width: '65%',
    '& .MuiLinearProgress-bar': {
      backgroundColor: 'red',
      borderRadius: '4px',
    }
  },
  progressBarGreen: {
    height: '17px',
    borderRadius: '4px',
    backgroundColor: '#E0E0E0',
    width: '65%',
    '& .MuiLinearProgress-bar': {
      backgroundColor: '#4CAF50',
      borderRadius: '4px',
    }
  },
  remainingTimeText: {
    fontSize: '14px',
    color: '#333',
    textAlign: 'center',
    margin: 0,
    fontWeight: 600
  }
}));

export default styles;